import React from "react";
import * as Yup from "yup";

import { IPayeeUpdateRequest } from "@wingspanhq/payments/dist/interfaces";
import {
  useWSSnackbar,
  WSActions,
  WSForm,
  WSInfoBox,
  WSInputTextarea,
  WSList
} from "@wingspanhq/fe-component-library";

import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { queriesPayees } from "@query";
import { useXWingspanPayerId } from "../../routes/RoutePayeeDetails/useXWingspanPayerId";
import { ErrorContextKey } from "../../../../services/platform";

type Props = {
  payeeId: string;
  internalNotes?: string;
  onClose: () => void;
};

export const InternalNotesModal: React.FC<Props> = ({
  payeeId,
  internalNotes,
  onClose
}) => {
  const { openSnackbar } = useWSSnackbar();
  const xWingspanAccount = useXWingspanPayerId();
  const [updatePayee, updatePayeeMeta] =
    queriesPayees.updatePayee.useMutation();
  const onSubmit = async (data: IPayeeUpdateRequest["payerOwnedData"]) => {
    await updatePayee(
      {
        payeeId,
        payeeUpdate: {
          internalNotes: data.internalNotes
        },
        xWingspanAccount
      },
      {
        onSuccess: () => {
          openSnackbar({
            message: "Internal notes updated successfully",
            type: "success"
          });
          onClose();
        }
      }
    );
  };
  return (
    <>
      <WSForm<IPayeeUpdateRequest["payerOwnedData"]>
        defaultValues={{
          internalNotes: internalNotes || ""
        }}
        validationSchema={Yup.object().shape({
          internalNotes: Yup.string()
            .required("Required")
            .max(2000, "Max 2000 characters allowed")
        })}
        onSubmit={onSubmit}
      >
        <WSList gap="XL">
          <WSForm.Field
            name="internalNotes"
            label="Notes"
            component={WSInputTextarea}
            componentProps={{
              required: true
            }}
          />

          <WSInfoBox>
            The internal note is visible to you and your team only.
          </WSInfoBox>

          <WSErrorMessage
            contextKey={ErrorContextKey.EditPayerPayeeInternalNotes}
            error={updatePayeeMeta.error}
          />

          <WSActions
            buttons={[
              {
                label: "Cancel",
                onClick: onClose,
                kind: "Tertiary",
                fullWidth: true
              },
              {
                label: "Save changes",
                type: "submit",
                fullWidth: true,
                loading: updatePayeeMeta.isLoading
              }
            ]}
          />
        </WSList>
      </WSForm>
    </>
  );
};
